if (!customElements.get('ring-size-guide')) {
  class RingSizeGuide extends HTMLElement {
    constructor() {
      super();
      this.onTabClick = this.onTabClick.bind(this);
      this.onPrint = this.onPrint.bind(this);
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-ring-size-tab]');
      this.panels = this.querySelectorAll('[data-ring-size-panel]');
      this.printButton = this.querySelector('[data-ring-size-print]');
      this.printable = this.querySelector('.ring-size-guide__printable');

      this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick));
      this.printButton?.addEventListener('click', this.onPrint);

      this.addEventListener('click', (event) => {
        if (!event.target.closest('.ring-size-guide__dialog')) {
          this.closest('modal-dialog')?.hide();
        }
      });
    }

    disconnectedCallback() {
      this.tabs?.forEach((tab) => tab.removeEventListener('click', this.onTabClick));
      this.printButton?.removeEventListener('click', this.onPrint);
    }

    onTabClick(event) {
      const tab = event.currentTarget;
      const target = tab.dataset.ringSizeTab;
      if (!target) return;

      this.tabs.forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.ringSizePanel === target;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    onPrint() {
      if (!this.printable) {
        window.print();
        return;
      }

      const previousTitle = document.title;
      document.title = 'Οδηγός Μεγεθών Δαχτυλιδιού — Kewels';
      window.print();
      window.setTimeout(() => {
        document.title = previousTitle;
      }, 500);
    }
  }

  customElements.define('ring-size-guide', RingSizeGuide);
}
